import React, { useEffect } from 'react';
import { initFacebookPixel } from './components/facebookPixel';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { MidCTA } from './components/MidCTA';
import { SystemIntro } from './components/SystemIntro';
import { TomosGrid } from './components/TomosGrid';
import { BonusSection } from './components/BonusSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSection } from './components/PricingSection';
import { EliteDetail } from './components/EliteDetail';
import { ComparisonTable } from './components/ComparisonTable';
import { DecisionBlock } from './components/DecisionBlock';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    initFacebookPixel();
  }, []);
  return <div className="min-h-screen bg-mystic-900 font-sans text-slate-100 selection:bg-gold-500 selection:text-mystic-900" data-id="element-0">
      <Hero data-id="element-1" />
      <TrustBar data-id="element-2" />
      <Testimonials type="initial" data-id="element-3" />
      <PainPoints data-id="element-4" />
      <MidCTA data-id="element-5" />
      <SystemIntro data-id="element-6" />
      <TomosGrid data-id="element-7" />
      <BonusSection data-id="element-8" />
      <CountdownTimer data-id="element-9" />
      <PricingSection data-id="element-10" />
      <EliteDetail data-id="element-11" />
      <ComparisonTable data-id="element-12" />
      <DecisionBlock data-id="element-13" />
      <Testimonials type="final" data-id="element-14" />
      <Guarantee data-id="element-15" />
      <FAQ data-id="element-16" />
      <Footer data-id="element-17" />

      {/* Floating Elements */}
      <PurchasePopup data-id="element-18" />
    </div>;
}